import { catchError } from "../../utils/Helper";
import { addQueryParams } from "../../utils/helpers";
import { client } from "../axios/endpoint";
import { getRequest , postFormDataRequest, postRequest, deleteRequest} from "../axios/request";

export const getClientsById = async (id, query) => {
  try {
    const response = await getRequest(client.getClientsById(id), query);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const onboardClient = async (data) => {
  try {
    const response = await postRequest(client.onboardClient,data);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getClientDetails = async (data) => {
  try {
    const response = await getRequest(client.getClientDetails,data);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
}

export const getClientOnboardingProgress = async (clientId) => {
  try {
    const response = await getRequest(client.getClientOnboardingProgress(clientId));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
}

export const addTaskDetails = async (data) => {
  try {
    const response = await postFormDataRequest(client.addTaskDetails,data);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
}

export const getTaskDetailsById = async (id) => {

  try {
    const response = await getRequest(client.getTaskDetailsByTaskId(id));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
}

export const deleteClientById = async (productClientId) => {
  try {
    // Add productClientId as query parameter
    const url = `${client.deleteClientById}?productClientId=${productClientId}`;
    const response = await deleteRequest(url);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
}

export const deleteTaskDocumentsById = async (payload) => {
  try {
    const response = await deleteRequest(client.deleteTaskDocumentsById(payload.documentId), null, { productClientId: payload.productClientId });
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
} 

export const completeOnboarding = async (queryParams = {}) => {
  try {
    const url = addQueryParams(client.completeOnboarding, queryParams);
    const response = await postRequest(url, {});
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
}

export const clientApi = {
  onboardClient,
  getClientsById,
  getClientDetails,
  addTaskDetails,
  getTaskDetailsById,
  deleteClientById,
  deleteTaskDocumentsById,
  completeOnboarding
}; 